import React, { type PropsWithChildren, type ComponentProps } from "react";
import Box from "@material-ui/core/Box";
import InfoTooltip from "src/components/InfoTooltip";

interface RowProps {
  text?: string;
  className?: string;
  InfoTooltipProps?: Partial<ComponentProps<typeof InfoTooltip>>;
  id?: string;
}

export function Row({
  text,
  InfoTooltipProps,
  children,
  className,
  id,
}: PropsWithChildren<RowProps>) {
  return (
    <Box display="flex" className={className} id={id}>
      <Box mr={1} display="flex" alignItems="center">
        <InfoTooltip
          {...InfoTooltipProps}
          text={text}
          size={18}
          hidden={!text}
        />
      </Box>
      {children}
    </Box>
  );
}
